import { render } from "./ToDoChatChannelModel.vue?vue&type=template&id=557fdf2b&ts=true"
import script from "./ToDoChatChannelModel.vue?vue&type=script&lang=ts"
export * from "./ToDoChatChannelModel.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__